import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { BsFillPersonFill } from 'react-icons/bs';
import {
  HiOutlineDocumentText,
  HiOutlineCurrencyDollar,
  HiReceiptTax,
  HiOutlineEye,
} from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { IClientInvoice } from 'wisestep-api';
import { WsColors, WsTypography } from 'wisestep-base';

import { getCurrencySymbol } from '../../../../utils';
import InvoiceDetailsCard, { InvoiceDetailsCardAttribute, properties } from '../InvoiceDetailsCard';

export const getContractPlacementSellRate = (contractPlacement) =>
  `${getCurrencySymbol(contractPlacement?.sellRateCurrency?.symbol ?? '')} ${
    contractPlacement?.sellRateAmount
  } ${contractPlacement?.sellRateFrequency}`;

export const getContractPlacementUnits = (lineItem) =>
  `${lineItem.units} ${
    lineItem?.contractPlacement?.sellRateFrequency === 'HOURLY'
      ? 'hour(s)'
      : lineItem?.contractPlacement?.sellRateFrequency === 'WEEKLY'
      ? 'week(s)'
      : lineItem?.contractPlacement?.sellRateFrequency === 'MONTHLY'
      ? 'month(s)'
      : lineItem?.contractPlacement?.sellRateFrequency === 'ANNUALLY'
      ? 'year(s)'
      : ''
  }`;

const InvoiceDetailContractPlacementDetails = ({ invoice }: { invoice: IClientInvoice }) => {
  const navigate = useNavigate();
  const contractPlacementItems = invoice.lineItems.filter((item) => item.type === 'CLOSURE');

  return (
    <>
      {contractPlacementItems.map((item, index) => (
        <Box key={index} pt={2}>
          <InvoiceDetailsCard
            icon={<BsFillPersonFill color={WsColors.TheBlues500} size={22} />}
            right={
              <Tooltip title="View Placements" placement="top">
                <IconButton
                  sx={{ m: -1 }}
                  onClick={() => navigate('/placements/' + item.contractPlacement?.id)}
                >
                  <HiOutlineEye color={WsColors.GreyBlack} />
                </IconButton>
              </Tooltip>
            }
            title={item.contractPlacement?.candidate?.name ?? ''}
          >
            <InvoiceDetailsCardAttribute columns={4} tooltipTitle="Rate">
              <HiOutlineCurrencyDollar />
            </InvoiceDetailsCardAttribute>
            <InvoiceDetailsCardAttribute columns={5} tooltipTitle="Units">
              <HiReceiptTax />
              <WsTypography {...properties}>{getContractPlacementUnits(item)}</WsTypography>
            </InvoiceDetailsCardAttribute>
            <InvoiceDetailsCardAttribute columns={3} tooltipTitle="Invoice Amount">
              <HiOutlineDocumentText />
            </InvoiceDetailsCardAttribute>
          </InvoiceDetailsCard>
        </Box>
      ))}
    </>
  );
};

export default InvoiceDetailContractPlacementDetails;
